<template>
  <div class="datetime-range-buttom">
      <date-time-range :ref="column.prop"  :column="column"
       @dateChange="dateChange"></date-time-range>
      <div class="search-item">
        <el-button class="date-type-btn" :class="{'unchecked':dateTypeActive!=btn.value}"
          size="mini" v-for="btn in dateType" @click="dateTypeChange(btn.value)"
          :key="btn.value">{{btn.label}}</el-button>
      </div>
  </div>
</template>
<script>
import dateTimeRange from "@/components/controls/dateTimeRange";
export default {
  components:{dateTimeRange},
  props: ["column"],
  data() {
    return {
      endTime:'',
      startTime:'',
      dateTypeActive: 1,
      formatStr:'YYYY-MM-DD ',
      dateType: [
        { label: "今天", value: 1 },
        { label: "昨天", value: 2 },
        // { label: "近7天", value: 3 },
        { label: "本周", value: 4 },
        { label: "上周", value: 5 },
        { label: "本月", value: 6 },
        { label: "上月", value: 7 },
        { label: "本季", value: 8 },
        { label: "上季", value: 9 },
        { label: "今年", value: 10 },
      ],
    };
  },
  mounted(){
    if(this.column.rangeButton){
        this.dateType = this.column.rangeButton;
        this.formatStr = 'YYYY-MM-DD HH:mm:ss'
    }
    if(this.column.dateType == 'datetime'){
      this.formatStr = 'YYYY-MM-DD HH:mm:ss'
    }
    this.dateTypeChange(this.column.defaultValue||1);
  },
  methods: {
    dateChange(date){
      if((this.startTime+"," +this.endTime) != date){
        this.dateTypeActive = 0;
      }
    },
    clearData(){
       this.dateTypeChange(this.column.defaultValue||1);
    },
    //时间按钮点击
    dateTypeChange(value) {
      this.dateTypeActive = value;
      switch (value) {
        case 1://今天
          this.startTime = this.$moment().startOf('day').format(this.formatStr);
          this.endTime=this.$moment().endOf('day').format(this.formatStr);
          break;
        case 2://昨天
          this.startTime =this.$moment().subtract(1, "days").format('YYYY-MM-DD 00:00:00');
          this.endTime=this.$moment().subtract(1, "days").format('YYYY-MM-DD 23:59:59');
          break;
        case 3:
          this.startTime =this.$moment().add(-7, "days").format(this.formatStr);
          this.endTime=this.$moment().format(this.formatStr);
          break;
        case 4://本周
          this.startTime =this.$moment().week(this.$moment().week()).startOf("week").format(this.formatStr);
          this.endTime=this.$moment().week(this.$moment().week()).endOf("week").format(this.formatStr);
          break;
        case 5://上周
          this.startTime = this.$moment().week(this.$moment().week() - 1).startOf("week").format(this.formatStr);
          this.endTime=this.$moment().week(this.$moment().week() - 1).endOf("week").format(this.formatStr);
          break;
        case 6://本月
          this.startTime =this.$moment().month(this.$moment().month()).startOf("month").format(this.formatStr);
          this.endTime=this.$moment().month(this.$moment().month()).endOf("month").format(this.formatStr);
          break;
        case 7://上月
          this.startTime =this.$moment().month(this.$moment().month() - 1).startOf("month").format(this.formatStr);
          this.endTime=this.$moment().month(this.$moment().month() - 1).endOf("month").format(this.formatStr);
          break;
        case 8://本季
          this.startTime = this.$moment().startOf('quarter').format(this.formatStr)
          this.endTime= this.$moment().endOf('quarter').format(this.formatStr)
          break;
        case 9://上季
          this.startTime =this.$moment().quarter( this.$moment().quarter() - 1).startOf('quarter').format(this.formatStr);
          this.endTime=this.$moment().quarter( this.$moment().quarter() - 1).endOf('quarter').format(this.formatStr);
          break;
        case 10://今年
          this.startTime = this.$moment().startOf('year').format(this.formatStr);
          this.endTime=this.$moment().endOf('year').format(this.formatStr);
          break;
      }
      this.$refs[this.column.prop].setValue(this.startTime,this.endTime);
    },
    getFormData(){
      return this.$refs[this.column.prop].getFormData();
    }
  },
};
</script>
<style>
.search-item {
    display: inline-block;
    margin-bottom: 5px;
}
.date-type-btn.unchecked {
    border-color: #ccc;
    color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/dateTimeRangeButton.vue